let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("icADE"), load("ffEVr"), load("kEwWf"), load("h3G8d")]).then(() => parcelRequire('cul1e'));